/********/ (() => { // webpackBootstrap
  var __webpack_exports__ = {};
  window.PXUTheme.jsReadmore = {
    init: function($section) {
      // Add settings from schema to current object
      window.PXUTheme.jsReadmore = $.extend(this, window.PXUTheme.getSectionData($section));      
      // console.log('Hello World');
      // window.addEventListener('resize',window.PXUTheme.jsReadmore.toggleReadMore);
      // window.PXUTheme.jsReadmore.toggleReadMore();
    },
    toggleReadMore: function() {
      // console.log('toggle start');
      const readMoreDiv = 'div.read_more'
      if(window.innerWidth<768){
        console.log('smaller window');
        window.PXUTheme.jsReadmore.showReadMoreLinks(readMoreDiv); 
      }else{
        console.log('larger window');
        window.PXUTheme.jsReadmore.hideReadMoreLinks(readMoreDiv);
      }
    },
    showReadMoreLinks: function(readMoreDiv) {
      // console.log('show links');
      $(readMoreDiv).each(function(){
        const $content=$(this).find('>div.shg-rich-text');
        if($content[0].offsetHeight<$content[0].scrollHeight){
          // console.log('has scroll');
          if(!$content.next('a.read-more').length){
            $content.after('<a class="read-more">Read More</a>');
            const $link = $content.next('a.read-more');
            $link.on('click', () => {
              $content.toggleClass('extended');
              $link.text($content.hasClass('extended') ? 'Show Less' : 'Read More');
            });
          }
        }
      });
    },
    hideReadMoreLinks: function() {
      console.log('hide links');
      $('a.read-more').remove();
    },
    unload: function($section) {
      // Cleanup
    }
  };
})();  
/********/
